import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import fxViewComponent from '@/components/fxView'
const noFound = () => import('@/components/fxView/shared/noFound')
//-------------------------request_access----------------------------------------------------------------
const request_access = () => import('@/components/fxView/request/request_access')
//-------------------------task-list------------------------------------------------------------
const task_listing = () => import('@/components/fxView/task/task_listing')
//-------------------------manage-group------------------------------------------------------------
const group_listing = () => import('@/components/fxView/mange_group/group_listing')
const group_view = () => import('@/components/fxView/mange_group/group_view')
const group_add_edit = () => import('@/components/fxView/mange_group/group_add_edit')
//-------------------------reporting------------------------------------------------------------
const reportReporting = () => import('@/components/fxView/report/reporting')
const create_collateral_report = () => import('@/components/fxView/report/create_collateral_report')
const create_emir_report = () => import('@/components/fxView/report/create_emir_report')
const create_mifir_report = () => import('@/components/fxView/report/create_mifir_report')
const create_reporting_member_report = () => import('@/components/fxView/report/create_reporting_member_report')
//-------------------------coupon----------------------------------------------------------------
const couponListing = () => import('@/components/fxView/coupon/coupon_listing')
const createCoupon = () => import('@/components/fxView/coupon/create_coupon')
const subscriptionListing = () => import('@/components/fxView/coupon/subscription_listing')
const subscriptionDetail = () => import('@/components/fxView/coupon/subscription_detail')

//-----------------------NOTIFICATION LIST------------------------------------------------------
const notificationListing = () => import('@/components/fxView/notification/notification_listing')
const notificationListingOld = () => import('@/components/fxView/notification/notification_listing_old')

//-------------------------admin----------------------------------------------------------------
const adminListing = () => import('@/components/fxView/admin/admin_listing')
const adminView = () => import('@/components/fxView/admin/admin_view')
const adminAdd = () => import('@/components/fxView/admin/create_admin')
const rm_accuracy = () => import('@/components/fxView/admin/rm_accuracy')
//-------------------------email----------------------------------------------------------------
const emailListing = () => import('@/components/fxView/email/email_listing')
const createEmail = () => import('@/components/fxView/email/create_email')
//-------------------------client----------------------------------------------------------------
const clientListing = () => import('@/components/fxView/client/client_listing')
const logsView = () => import('@/components/fxView/client/logs_view')
const clientView = () => import('@/components/fxView/client/client_view')
const email_file = () => import('@/components/fxView/log/email_file')
//-----------------------------------------faq---------------------------------------------------
const faqCat = () => import('@/components/fxView/faq/create_category')
const faqArticle = () => import('@/components/fxView/faq/create_article')
const faqEditCat = () => import('@/components/fxView/faq/edit_category')
const faqEditArticle = () => import('@/components/fxView/faq/edit_article')
const catList = () => import('@/components/fxView/faq/category_listing')
const articleList = () => import('@/components/fxView/faq/article_listing')
//-------------------------admin-----------------------------------------------------------------
const adminLogin = () => import('@/components/fxView/admin/login')
const adminDashboard = () => import('@/components/fxView/admin/dashboard')
//-------------------------ticket-----------------------------------------------------------------
const createTicket = () => import('@/components/fxView/ticket/create_ticket')
const ticketListing = () => import('@/components/fxView/ticket/ticket_list')
const ticketView = () => import('@/components/fxView/ticket/ticket_view')

const internal_deposit_list = () => import('@/components/fxView/ticket/internal_deposit_list')
//-------------------------deposit---------------------------------------------------------------
const depositListing = () => import('@/components/fxView/deposit/deposit_listing')
const depositView = () => import('@/components/fxView/deposit/deposit_view')
const createDeposit = () => import('@/components/fxView/deposit/create_deposit')
const depositTransaction  = () => import('@/components/fxView/deposit/deposit_transaction')
//-------------------------bonus---------------------------------------------------------------
const bonusListing = () => import('@/components/fxView/bonus/bonus_listing')
const bonusView = () => import('@/components/fxView/bonus/bonus_view')
//-------------------------withdrawal------------------------------------------------------------
const createWithdrawal = () => import('@/components/fxView/withdrawal/create_withdrawal')
const withdrawalListing = () => import('@/components/fxView/withdrawal/withdrawal_listing')
const withdrawalListingAccount = () => import('@/components/fxView/withdrawal/withdrawal_account_list')
const withdrawalView = () => import('@/components/fxView/withdrawal/withdrawal_view')
//-------------------------trading-account-------------------------------------------------------
const createTrading = () => import('@/components/fxView/trading/create_trading')
const tradingListing = () => import('@/components/fxView/trading/trading_listing')
const tradingView = () => import('@/components/fxView/trading/trading_view')
//-------------------------search-list-------------------------------------------------------
const search = () => import('@/components/fxView/shared/search')
//-------------------------Useer PDF---------------------------------------------------------
const userPDF = () => import('@/components/fxView/client/pdf')
const notes = () => import('@/components/fxView/internal_notes/notes')

//-----------------------------change-password--------------------------------

const changepassword = () => import('@/components/fxView/change_password/change-password')

//------------------------------webinar---------------------------------------------

const Webinar = () => import('@/components/fxView/webinar/add_webinar')

//--------------------------------tutorial-----------------------------------------
const Tutorial = () => import('@/components/fxView/Tutorial/tutorials')
const createTutorial = () => import('@/components/fxView/Tutorial/create-tutorial')

//-----------------------------------category--------------------------------------
const addCategory = () => import('@/components/fxView/category/add-category')
const addPost = () => import('@/components/fxView/category/add-post')
const categoryList = () => import('@/components/fxView/category/category-list')
const postList = () => import('@/components/fxView/category/post-list')



//-------------------------------------chart-----------------------------------------

const Chart = () => import('@/components/fxView/mapchart/chart')
const chartDesign = () => import('@/components/fxView/mapchart/chart-design')

const Editor = () => import('@/components/fxView/shared/editor')


Vue.use(Router)
const router =  new Router({
	mode: 'history',
	routes: [
		//-------------------------admin-login--------------------------------------------------
		{ path: '/', name: 'admin.adminLogin', component: adminLogin },
		{ path: '/clientpdf', name: 'client.userPDF',  props : true, component: userPDF },
		
		{
			path:'/',
			component: fxViewComponent,
			children:[
				{ path: '/view-email', name: 'log.email_file',  props : true, component: email_file },
				{ path: '/not-found', name: 'noFound',  component: noFound },
				{ path: '/request-access', name: 'request.request_access',  component: request_access },
				//-------------------------task-list------------------------------------------------
				{ path: '/task-listing', name: 'task.task_listing',  component: task_listing },
				{ path: '/notes', name: 'internal_notes.notes',  props : true, component: notes },
				//-------------------------manage-group------------------------------------------------
				{ path: '/group-listing', name: 'mange_group.group_listing',  component: group_listing },
				{ path: '/group-view', name: 'mange_group.group_view',  component: group_view },
				{ path: '/add-edit', name: 'mange_group.group_add_edit',  component: group_add_edit },
				//-------------------------reporting------------------------------------------------
				{ path: '/coupon-listing', name: 'coupon.couponListing',  component: couponListing },
				{ path: '/create-coupon', name: 'coupon.createCoupon',  component: createCoupon },
				{ path: '/subscription-listing', name: 'coupon.subscriptionListing',  component: subscriptionListing },
				{ path: '/subscription-detail', name: 'coupon.subscriptionDetail',  component: subscriptionDetail },
				//-------------------------reporting------------------------------------------------
				{ path: '/reporting', name: 'report.reportReporting',  component: reportReporting },
				{ path: '/create-collateral-report', name: 'report.create_collateral_report',  component: create_collateral_report },
				{ path: '/create-emir-report', name: 'report.create_emir_report',  component: create_emir_report },
				{ path: '/create-mifir-report', name: 'report.create_mifir_report',  component: create_mifir_report },
				{ path: '/create-reporting-member-report', name: 'report.create_reporting_member_report',  component: create_reporting_member_report },
				//-------------------------admin------------------------------------------------
				{ path: '/search', name: 'shared.search',  component: search },

				{ path: '/notification-list', name: 'admin.notificationListing',  component: notificationListing },
				{ path: '/notification-list-old', name: 'admin.notificationListingOld',  component: notificationListingOld },

				//-------------------------admin------------------------------------------------
				{ path: '/admin-list', name: 'admin.adminListing',  component: adminListing },
				{ path: '/admin-view',  name: 'admin.adminView', props : true, component: adminView },
				{ path: '/create-admin',  name: 'admin.adminAdd', props : true, component: adminAdd },
				{ path: '/rm-accuracy',  name: 'admin.rm_accuracy', props : true, component: rm_accuracy },
				//-------------------------email------------------------------------------------
				{ path: '/email-setting-list', name: 'email.emailListing',  component: emailListing },
				{ path: '/create-email',  name: 'email.createEmail', props : true, component: createEmail },
				//-------------------------client------------------------------------------------
				{ path: '/listing', name: 'client.clientListing',  component: clientListing },
				{ path: '/logs-view',  name: 'client.logsView', props : true, component: logsView },
				{ path: '/view',  name: 'client.clientView', props : true, component: clientView },
				
				//-------------------------faq---------------------------------------------------
				{ path: '/category',  name: 'faq.faqCat', props : true, component: faqCat },
				{ path: '/articles',  name: 'faq.faqArticle', props : true, component: faqArticle },
				{ path: '/edit-category',  name: 'faq.faqEditCat', props : true, component: faqEditCat },
				{ path: '/edit-article',  name: 'faq.faqEditArticle', props : true, component: faqEditArticle },
				{ path: '/category-list',  name: 'faq.catList', props : true, component: catList },
				{ path: '/articles-list',  name: 'faq.articleList', props : true, component: articleList },
				//-------------------------ticket------------------------------------------------
				{ path: '/create-ticket', name: 'ticket.createTicket',  component: createTicket },
				{ path: '/ticket-list', name: 'ticket.ticketListing',  component: ticketListing },
				{ path: '/ticket-view',  name: 'ticket.ticketView', props : true, component: ticketView },
				{ path: '/internal-deposit-list', name: 'ticket.internal_deposit_list',  component: internal_deposit_list },
				//-------------------------deposit-----------------------------------------------
				{ path: '/create-deposit',  name: 'deposit.createDeposit', props : true, component: createDeposit },
				{ path: '/deposit-list',  name: 'deposit.depositListing',  component: depositListing },
				{ path: '/deposit-view',  name: 'deposit.depositView', props : true, component: depositView },
				{  path: '/transaction-history',  name: 'deposit.depositTransaction',  component: depositTransaction },
				//-------------------------bonus-----------------------------------------------
				{ path: '/bonus-list',  name: 'bonus.bonusListing',  component: bonusListing },
				{ path: '/bonus-view',  name: 'bonus.bonusView', props : true, component: bonusView },
				//-------------------------withdrawal--------------------------------------------
				{ path: '/create-withdrawal', name: 'withdrawal.createWithdrawal',  component: createWithdrawal },
				{ path: '/withdrawal-list',  name: 'withdrawal.withdrawalListing', component: withdrawalListing },
				{ path: '/withdrawal-account-list',  name: 'withdrawal.withdrawalListingAccount', component: withdrawalListingAccount },
				{ path: '/withdrawal-view',  name: 'withdrawal.withdrawalView',  props : true, component: withdrawalView },
				//-------------------------trading-account---------------------------------------
				{ path: '/create-trading',  name: 'trading.createTrading', component: createTrading },
				{ path: '/trading-list',  name: 'trading.tradingListing', component: tradingListing },
				{ path: '/trading-view',  name: 'trading.tradingView',  props : true, component: tradingView },
				//-------------------------admin-------------------------------------------------
				{ path: '/dashboard',   name: 'admin.adminDashboard',  component: adminDashboard },

				//--------------------------------change password---------------------------------
				{ path: '/change-password',   name: 'change_password.changepassword',  component: changepassword },

				//--------------------------------webinar---------------------------------
				{ path: '/webinar',   name: 'add_webinar.Webinar',  component: Webinar },

				//---------------------------------tutorial------------------------------------
				{ path: '/tutorials-list',   name: 'Tutorial.Tutorial',  component: Tutorial },
				{ path: '/create-tutorial',   name: 'Tutorial.createTutorial',  component: createTutorial },


				//-------------------------------------category-----------------------------------------

				{ path: '/add-category',   name: 'category.addCategory',  component: addCategory },
				{ path: '/add-post',   name: 'category.addPost',  component: addPost },
				{ path: '/category-Listing',   name: 'category.categoryList',  component: categoryList },
				{ path: '/post-list',   name: 'category.postList',  component: postList },

				//----------------------------------------chart-------------------------------------------

				{ path: '/chart',   name: 'mapchart.Chart',  component: Chart },
				{ path: '/chart-design',   name: 'mapchart.chartDesign',  component: chartDesign },
				{ path: '/editor',   name: 'shared.Editor',  component: Editor },

			]
		}, 

		
		   
	]
})

router.beforeEach((to, from, next) => {
	const userStateVariable = store.state.user
	//let permissionVariable = userStateVariable.permissions.split(',')
	//console.log(permissionVariable.indexOf('ADMIN_LIST'))
	if (to.name !== 'admin.adminLogin'   && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) next({ name: 'admin.adminLogin' })
	
	//else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == 'admin.adminListing' && permissionVariable.indexOf('ADMIN_LIST') >= 0) next({ name: 'admin.adminListing' })
	 
	//else if(userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == '' && ) next({ name: '' })
	
	else next()
	
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js